import TemplateView from "../../../TemplateView"
import UserTime from "../../../user_time"
import {getColorClassById} from "../../../workflowStatus/utils"
import CustomCheckbox from '../../../components/customCheckbox/CustomCheckbox'
import TaskCardName from "./TaskCardName"
import {escapeHtmlSymbols} from "../../../atUtils"
import messageResource from "../../../messageResource"
import CommentsNumberContainer from '../../components/CommentsNumberContainer'
import {isCtrlPressed, isMetaPressed} from '../../../keyHandlers'
import {setEventPreventHidingEditTaskSlidingPanel} from '../../../panels/utils'
import SimpleTooltip from '../../../SimpleTooltip'
import $ from "jquery"

export default class TaskCard extends TemplateView {
    constructor({
        onClick = () => {},
        onChangeSelect = () => {},
        onCardActiveSelectionDisappear = () => {},
        onMoveToTopClick = () => {},
        onMoveToBottomClick = () => {},
    }) {
        super()

        this.state = {
            name: "",
            highlightedName: "",
            spentTime: 0,
            estimatedTime: 0,
            commentsNumber: 0,
            colorId: 0,
            disabled: false,
            selected: false,
            selectionDisabled: false,
            detailsOpen: false,
            isLastCreatedTask: false,
            recentlyCreated: false,
            minimized: false,
            selectable: false,
            showEstimate: false,
            showMoveToTopBtn: false,
            showMoveToBottomBtn: false,
        }

        this.onClick = onClick
        this.onChangeSelect = onChangeSelect
        this.onCardActiveSelectionDisappear = onCardActiveSelectionDisappear
        this.onMoveToTopClick = onMoveToTopClick
        this.onMoveToBottomClick = onMoveToBottomClick

        this.onAnyStatePropertyChanged(['name', 'highlightedName'], () => this._updateName())
        this.onStatePropertyChanged('spentTime', spentTime => this._updateSpentTime(spentTime))
        this.onStatePropertyChanged('estimatedTime', estimatedTime => this._updateEstimatedTime(estimatedTime))
        this.onStatePropertyChanged('colorId', (colorId, prevColorId) => this._updateColor(colorId, prevColorId))
        this.onStatePropertyChanged('detailsOpen', detailsOpen => this._updateDetailsOpen(detailsOpen))
        this.onStatePropertyBecameTrue('isLastCreatedTask', () => this._updateLastCreated())
        this.onStatePropertyChanged('recentlyCreated', recentlyCreated => this._updateRecentlyCreated(recentlyCreated))
        this.onStatePropertyChanged('minimized', minimized => this._updateMinimized(minimized))
        this.onStatePropertyChanged('disabled', disabled => this._updateDisabled(disabled))
        this.onAnyStatePropertyChanged(['editable', 'selected', 'selectionDisabled', 'selectable'], () => this._updateCheckbox())
        this.onStatePropertyChanged('commentsNumber', commentsN => this._updateCommentsNumber(commentsN))
        this.onStatePropertyChanged('showEstimate', showEstimate => this.$estimatedTime.toggle(showEstimate))
        this.onStatePropertyChanged('selectable', selectable => this.getEl().toggleClass('cardWithCheckbox', selectable))
        this.onStatePropertyChanged('showMoveToTopBtn', showMoveToTopBtn => this.$btnUp.toggleClass('hidden', !showMoveToTopBtn))
        this.onStatePropertyChanged('showMoveToBottomBtn', showMoveToBottomBtn => this.$btnDown.toggleClass('hidden', !showMoveToBottomBtn))
    }

    templateHtml() {
        return "<div class='kanbanView_components_taskCard'>" +
               "  <div class='content'></div>" +
               "  <div class='footer'>" +
               "    <div class='time'>" +
               "      <div class='trackedTime'></div>" +
               "      <div class='estimatedTime'></div>" +
               "    </div>" +
               "    <div class='commentsNumberPlaceholder'></div>" +
               "  </div>" +
               "  <div class='buttons'>" +
               "    <span class='buttonUp' tooltipText='<%=buttonUpTooltip%>'></span>" +
               "    <span class='spacer'></span>" +
               "    <span class='buttonDown' tooltipText='<%=buttonDownTooltip%>'></span>" +
               "  </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            buttonUpTooltip: 'task.list.kanban.task_card.button_up_tooltip',
            buttonDownTooltip: 'task.list.kanban.task_card.button_down_tooltip',
        }
    }

    templateModel() {
        return {
            showMoveToTopBtn: this.state.showMoveToTopBtn,
            showMoveToBottomBtn: this.state.showMoveToBottomBtn,
        }
    }

    afterRender() {
        const $content = this.find('.content')
        this.checkbox = new CustomCheckbox({
            containerAdditionalClass: 'checkboxContainer',
            tabindex: -1,
            onChange: ({checked}) => {
                if (!this.state.disabled) {
                    this.onChangeSelect(checked)
                }
            }
        }).init($content)
        this.taskCardName = new TaskCardName().init($content)

        this.$trackedTime = this.find('.trackedTime')
        this.$estimatedTime = this.find('.estimatedTime')

        this.$el.click((e) => {
            setEventPreventHidingEditTaskSlidingPanel(e)
            if (!this.state.disabled) {
                // for comfortable selection of cards
                if (this.state.selectable && (isCtrlPressed(e) || isMetaPressed(e))) {
                    this.onChangeSelect(!this.state.selected)
                } else {
                    this.onClick()
                }
            }
        })

        this.commentsNumber = new CommentsNumberContainer().init(this.find('.commentsNumberPlaceholder'))

        this.$btnUp = this.find('.buttonUp')
        this.$btnDown = this.find('.buttonDown')

        const tooltip = this._getTaskCardTooltip()
        tooltip.subscribeToMouseEvents(this.$btnUp)
        tooltip.subscribeToMouseEvents(this.$btnDown)

        this.$btnUp
            .click(this.onMoveToTopClick)
            .mouseenter(() => tooltip.setText(this.$btnUp.attr('tooltipText')))
        this.$btnDown
            .click(this.onMoveToBottomClick)
            .mouseenter(() => tooltip.setText(this.$btnDown.attr('tooltipText')))

        this.renderInitialState()
    }

    _updateName() {
        this.taskCardName.setState({
            html: this.state.highlightedName || escapeHtmlSymbols(this.state.name)
        })
    }

    _updateSpentTime(spentTime) {
        this.$trackedTime.text(UserTime.formatTimeWithDigitSeparator(spentTime))
    }

    _updateEstimatedTime(estimatedTime) {
        let text = ''
        if (estimatedTime > 0) {
            text = messageResource.getEscapedMessage(
                'task.list.kanban.task_card.estimated_time', [UserTime.formatTimeWithDigitSeparator(estimatedTime)]
            )
        }
        this.$estimatedTime.text(text)
    }

    _updateColor(colorId, prevColorId) {
        if (prevColorId) {
            this.$el.removeClass(getColorClassById(prevColorId))
        }
        this.$el.addClass(getColorClassById(colorId))
    }

    _updateDetailsOpen(detailsOpen) {
        this.$el.toggleClass('activeCard', detailsOpen)
    }

    _updateLastCreated() {
        this.$el.addClass('lastCreated')
        this.$el.atAnimation().showAnimated('anim-border-hide', () => {
            this.$el.removeClass('lastCreated')
            this.onCardActiveSelectionDisappear()
        })
    }

    _updateRecentlyCreated(recentlyCreated) {
        this.$el.toggleClass('recentlyCreated', recentlyCreated)
    }

    _updateMinimized(minimized) {
        this.$el.toggleClass('minimized', minimized)
    }

    _updateDisabled(disabled) {
        this.$el.toggleClass('disabled', disabled)
        this._updateCheckbox()
    }

    _updateCheckbox() {
        this.$el.toggleClass('selectedCard', this.state.selected)
        this.checkbox.toggle(this.state.selectable)
        this.checkbox.setState({
            checked: this.state.selected,
            disabled: this.state.selectionDisabled || this.state.disabled,
        })
    }

    _updateCommentsNumber(number) {
        this.commentsNumber.setState({
            commentsNumber: number,
        })
    }

    /*
     * All task cards on the page use the same tooltip element
     */
    _getTaskCardTooltip() {
        if (!TaskCard.tooltip) {
            TaskCard.tooltip = new SimpleTooltip().init($('body'))
        }
        return TaskCard.tooltip
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/TaskCard.js